// extracted by mini-css-extract-plugin
export default {"container":"KN-z","topReviewHeading":"LN-z","criticalReview":"MN-z","favorableReview":"NN-z","vsSeparator":"ON-z"};